import { render, staticRenderFns } from "./PortalHeader.vue?vue&type=template&id=3e94bf7d&scoped=true&"
import script from "./PortalHeader.vue?vue&type=script&lang=js&"
export * from "./PortalHeader.vue?vue&type=script&lang=js&"
import style0 from "./PortalHeader.vue?vue&type=style&index=0&id=3e94bf7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e94bf7d",
  null
  
)

export default component.exports